import React from 'react';
import Select, { components } from 'react-select';
import jQuery from 'jquery';
import Helping from '../../helpers/Helping';

let updateCallback = (res) => {
}

export const setFilterValue = (callback) => {
  updateCallback = callback;
}

export const convertArrayToOptionsList = (valuesArray, valueToBeSelected, valueToBeSelectedKey, dependency, field) => {

  var options = valuesArray && valuesArray.map((row, i) => {
    const opt = {};
    opt.name = field;
    opt.value = row[valueToBeSelected];

    if (typeof row[dependency] === 'object' && !jQuery.isEmptyObject(row[dependency]))
      opt.label = `<b>${opt.value}</b></br>${row[valueToBeSelectedKey[0]]} => ${row[dependency][valueToBeSelectedKey[1]]}`;

    else if (valueToBeSelectedKey.length <= 1)
      opt.label = `<b>${opt.value}</b></br>${row[valueToBeSelectedKey[0]]}`;
    else
      opt.label = `<b>${opt.value}</b></br>${row[valueToBeSelectedKey[0]]} ${row[valueToBeSelectedKey[1]]}`;

    return opt;
  });

  if (options)
    options.unshift({ name: '', value: '', label: `Select ${Helping.getTitleCase(field)}...` });

  return options;
}

const SingleValue = props => (
  <components.SingleValue {...props}>
    {props.data.value ? props.data.value : props.data.label}
  </components.SingleValue>
);

const DropDown = ({
  id,
  field,
  name,
  valuesArray,
  valueToBeSelected,
  valueToBeSelectedKey,
  selectChangeFunction,
  userSelectedFieldValue,
  dependency = {},
  callback
}) =>

  <Select
    id={id}
    className="basic-single"
    classNamePrefix="form-select"
    isSearchable={true}
    isClearable={false}
    // menuIsOpen={true}
    name={name}
    defaultValue={userSelectedFieldValue}
    components={{ SingleValue }}
    placeholder={`Select ${Helping.getTitleCase(field)}...`}
    ref={ref => callback(name, ref)}
    options={convertArrayToOptionsList(valuesArray, valueToBeSelected, valueToBeSelectedKey, dependency, field)}
    onChange={(e) => {
      selectChangeFunction(e);
      
      if (e)
        updateCallback(e.value);
    }}

    formatOptionLabel={function (data) {
      return (
        <span dangerouslySetInnerHTML={{ __html: data.label }} />
      );
    }}
  />

export default DropDown;